import React, { FC } from 'react'

import FeedItem from './FeedItem'

const Feed: FC = () => {
  return (
    <div className="h-screen pt-4">
      <FeedItem />
    </div>
  )
}

export default Feed
